export default "__VITE_ASSET__e52d3f3b__"